import React from 'react';
import PropTypes from 'prop-types';
// import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery, Grid, Typography, } from '@material-ui/core';
import { SectionHeader } from 'components/molecules';
import { CardBase } from 'components/organisms';
import { Image } from 'components/atoms';
import Alloseqdna from 'components/Popups/Caredx/Alloseqdna'
import Alloseqtmt from 'components/Popups/Caredx/Alloseqtmt'
import Alloseqtx from 'components/Popups/Caredx/Alloseqtx'
// import Olerupsbt from 'Components/Popups/Caredx/Olerupsbt'
// import Olerupssp from 'Components/Popups/Caredx/Olerupssp'
// import Olerupxmone from 'Components/Popups/Caredx/Olerupxmone'
import Qtype from 'components/Popups/Caredx/Qtype'
// import Trusight from 'Components/Popups/Caredx/Trusight'





const useStyles = makeStyles(theme => ({
  cardBase: {
    '&:hover': {
      background: '#7DEDFF',
      '& .card-icon, & .card-title': {
        color: 'white',
      },
    },
  },
  icon: {
    fontSize: 60,
    color: theme.palette.primary.main,
    [theme.breakpoints.up('sm')]: {
      fontSize: 80,
    },
  },
  title: {
    marginTop: theme.spacing(4),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(6),
    },
  },

}));

const Caredxall = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <div className={className} {...rest}>
             <CardBase >

<Image src="https://ik.imagekit.io/j6phbjneuop/01e95876-18a6-4004-9b2f-eb36449aaf6f_CQR1YIEOxxl.jpg" />

</CardBase>

<br/>

      <SectionHeader
        title="Featured products"
        subtitle=" Care-dx "
        data-aos="fade-up"
      />


      <Grid container spacing={isMd ? 4 : 2}>
        <Grid item xs={12} sm={4} data-aos="fade-up">
          <CardBase withShadow liftUp className={classes.cardBase}>
            <div>
              <Image src="https://ik.imagekit.io/j6phbjneuop/Alloseqtx-min_Hw3D42A3z.png" />


            </div>

            <br />


            <Typography variant="h5" component="span" className={classes.fontWeight900}>
              <h3> AlloSeq  </h3>  &nbsp;
              <Typography component="span" variant="inherit" color="primary">Tx 17</Typography>
            </Typography>



            <br />
            <br />

            <Alloseqtx />
          </CardBase>
        </Grid>
        <Grid item xs={12} sm={4} data-aos="fade-up">
          <CardBase withShadow liftUp className={classes.cardBase}>
            <div>
              <Image src="https://ik.imagekit.io/j6phbjneuop/caredx/alloseq8_e-7Ng2N6n.png" />
            </div>
            <br/>
            <br/>
            <Typography variant="h5" component="span" className={classes.fontWeight900}>
              <h3> AlloSeq</h3>  &nbsp;
              <Typography component="span" variant="inherit" color="primary">TX8</Typography>
            </Typography>



            <br />
            <br />

            <Alloseqtmt />
            {/* <Typography
              variant="h5"
              color="textPrimary"
              align="center"
              noWrap
              // className={clsx(classes.title, 'card-title')}
            >
Single Cell
 Gene Expression 
            </Typography> */}


          </CardBase>
        </Grid>
        <Grid item xs={12} sm={4} data-aos="fade-up">
          <CardBase withShadow liftUp className={classes.cardBase}>
            <div>
              <Image src="https://ik.imagekit.io/j6phbjneuop/caredx/alloseghct_E0Q2w-vN8.png" />
            </div>
            <br/>
            <br/>
            <Typography variant="h5" component="span" className={classes.fontWeight900}>
              <h3> 	AlloSeq </h3>  &nbsp;
              <Typography component="span" variant="inherit" color="primary"> HCT</Typography>
            </Typography>

            <br />
            <br />

            <Alloseqdna />
          </CardBase>
        </Grid>
      </Grid>
      <Grid container spacing={isMd ? 4 : 2}>
        <Grid item xs={12} sm={4} data-aos="fade-up">
          <CardBase withShadow liftUp className={classes.cardBase}>





            <div>
              <Image src="https://ik.imagekit.io/j6phbjneuop/caredx/qtype_MNB2krWU-.png" />
            </div>
            <Typography variant="h5" component="span" className={classes.fontWeight900}>
              <h3> QTYPE</h3>  &nbsp;
              <Typography component="span" variant="inherit" color="primary"></Typography>
            </Typography>


            <br />
            <br />

            <Qtype />
          </CardBase>
        </Grid>
        
      
      
       
          
    

      </Grid>
    </div>
  );
};

Caredxall.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Caredxall;
